import * as React from "react";
import { StoreState } from "../types";

import "./../styles/DataTable.css";
import { reportColumnData, spellOutState } from "../../refdata/ReportFormat";
import { NoData, Table } from "./DataTableComponents";
import DataSummary from "./../containers/DataSummary";
import { fetchData } from "../services/ApiClient";

export interface Props {
  columns: StoreState.Columns;
  displayFields: StoreState.Query["displayFields"];
  aggReport: StoreState.Query["aggReport"];
  apiUrl: string;
  onStartRequest: () => void;
  onResultSuccess: () => void;
  onResultFailure: (error: Error) => void;
}

interface State {
  resultData: any;
  resultTotals: any;
  recordCount: number;
}

const initialState = { resultData: null, resultTotals: null, recordCount: 0 };

class DataTable extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = initialState;
  }

  shouldComponentUpdate(nextProps: any, nextState: any) {
    const resultChanged = nextState.resultData !== this.state.resultData;
    const urlChanged = nextProps.apiUrl !== this.props.apiUrl;

    return resultChanged || urlChanged;
  }

  componentDidMount() {
    // fetch data on initial mount
    if (this.props.apiUrl) {
      this.updateData();
    }
  }

  componentDidUpdate(prevProps: any) {
    // when props change, only re-fetch if it is a new URL
    if (this.props.apiUrl !== prevProps.apiUrl) {
      // this.setState(initialState)
      this.updateData();
    }
  }

  updateData() {
    // See also: https://reactjs.org/docs/faq-ajax.html
    this.props.onStartRequest();
    fetchData(this.props.apiUrl)
      .then(response => {
        response.data.forEach(
          (res: any) => (res.PSTALP = spellOutState(res.PSTALP)),
        );
        this.setState({
          resultData:
            this.props.aggReport === "by_state"
              ? this.sortByProperty("PSTALP", response.data)
              : response.data,
          resultTotals: response.totals,
          recordCount: response.totals.count,
        });
        this.props.onResultSuccess();
      })
      .catch((error: Error) => {
        this.props.onResultFailure(error);
      });
  }

  sortByProperty(property: string, resultData: any) {
    return resultData.sort((a: any, b: any) => {
      return a[property] > b[property] ? 1 : -1;
    });
  }

  render() {
    const { columns, displayFields, aggReport } = this.props;
    const resultData = this.state.resultData;
    const resultTotals = this.state.resultTotals;
    if (!resultData || (resultTotals && resultTotals.count === 0)) {
      return NoData;
    }
    let table;
    if (aggReport) {
      if (aggReport !== "detail") {
        // render the table w/ agg info inserted from reference file
        const aggFields = reportColumnData("failures", aggReport, columns)[0];
        const aggCols = reportColumnData("failures", aggReport, columns)[1];
        table = Table({
          columns: aggCols,
          resultData: resultData,
          resultTotals: resultTotals,
          displayFields: aggFields,
          allowSort: false,
        });
        return (
          <React.Fragment>
            <DataSummary recordCount={this.state.recordCount} />
            <div
              className="ds-c-tabs__panel scrollable-fixed-height overflow-x-auto overflow-y-auto"
              id="panel-table-uncollapsed-view-id"
              aria-labelledby="tab-table-view"
              role="tabpanel"
            >
              {table}
            </div>
          </React.Fragment>
        );
      } else {
        // for detail report, render it normally, but w/ totals
        table = Table({
          columns,
          resultData: resultData,
          resultTotals: resultTotals,
          displayFields,
        });
      }
    } else {
      // render the table for non-aggregate (normal/detail) results
      table = Table({ columns, resultData: resultData, displayFields });
    }
    return (
      <React.Fragment>
        <DataSummary recordCount={this.state.recordCount} />
        <div
          className="ds-c-tabs__panel scrollable-fixed-height overflow-x-auto overflow-y-auto"
          id="panel-table-uncollapsed-view-id"
          aria-labelledby="tab-table-view"
          role="tabpanel"
        >
          {table}
        </div>
      </React.Fragment>
    );
  }
}

export default DataTable;
